
import React, {useState} from 'react';
import RegistrationForm from "../../forms/registration/RegistrationForm";

import "../../App.css";

import ScientistImage from "../../images/scientists.png";
import ConsentForm from "../../forms/legalese/ConsentForm";
import {Button, Card, CircularProgress, ThemeProvider} from "@mui/material";
import {net_registrationCreate} from "../../net/RegistrationCalls";
import {THEME} from "../../theme/PacsTheme";
import {isNotNull, isNull} from "../../util/Validators";
import FormModal from "../../modals/form-modal/FormModal";

export default function RegistrationPane(props) {

    const setSelected = props.setSelected;

    const [modalOpen, setModalOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [consentValuesMissing, setConsentValuesMissing] = React.useState(false);
    const [validate, setDoValidate] = React.useState(false);
    const [data, setData] = React.useState({

    });

    const isConsentIncomplete = () => {

        if (isNotNull(data.consent)) {

            let count = 0;
            const keys = Object.keys(data.consent)

            keys.forEach(key => {

                if (key !== "employee") {
                    count += data.consent[key].checked ? 0 : 1;
                } else {
                    count += isNull(data.consent[key]) || data.consent[key].length === 0 ? 1 : 0;
                }
            })

            if (count > 0) {
                setConsentValuesMissing(true);
            } else {
                setConsentValuesMissing(false);
            }

            return count > 0;
        } else {
            setConsentValuesMissing(true);
        }

        return true;
    }

    const hasErrors = () => {

        if (isNull(data.attendee)) {
            return true;
        }


        let count = 0;

        const value = data.attendee;
        const keys = Object.keys(value);

        keys.forEach(key=>{
            const val = value[key];
            count += val.error ? 1 : 0;
        })

        return count > 0;
    }

    const marshallPayload = () => {

        const ret = {};
        const keys = Object.keys(data.attendee);

        keys.forEach(key => {
            ret[key] = data.attendee[key].value;
        })

        return ret;
    }

    const doSubmit = () => {

        const payload = marshallPayload();

        setSubmitting(true);

        net_registrationCreate(payload, (response) => {

            switch (response.code) {
                case 200:
                    setSelected(6);
                    break;
                case 400:
                    alert("An error occured creating the registration. Please try again in a few minutes");
                    break;
                case 424:
                    alert("A registration associated with this email address already exists.");
                    break;
                default:
                    alert("Unexpected error code");
                    break;
            }

            setSubmitting(false);

        }, error => {
            console.warn(error.message);
        });
    }

    const handleSubmit = (e) => {

        e.preventDefault();

        const hasError = hasErrors();
        const isIncomplete = isConsentIncomplete();

        if (isNull(data.consent) || isIncomplete || isNull(data.attendee) || hasError) {
            setDoValidate(true);
        } else {

            if (data.consent.employee === "Neither of the above") {
                doSubmit();
            } else {
                setModalOpen(true);
            }
        }
    }

    const onWatch = (name, values) => {
        setData({...data, [name]: values});
    }

    const handleValidate = () => {
        setDoValidate(false);
    }

    const handleCloseModal = () => {
        setModalOpen(false);
        window.location = "/";
    }

    return (
        <React.Fragment>

            <div
                style={{
                    display: "inline-block",
                    maxWidth: "900px",
                    width: "100%"
                }}
                className={"default-align-center default-text-align-center default-justify-center"}
            >
                {/*<div*/}
                {/*    style={{*/}
                {/*        padding: "0 25px 0 25px"*/}
                {/*    }}*/}
                {/*    className={"default-margin-top-xlarge"}>*/}
                {/*    <img*/}
                {/*        style={{*/}
                {/*            borderRadius: "10px 10px 0 0",*/}
                {/*            maxWidth: "600px"*/}
                {/*        }}*/}
                {/*        src={ScientistImage}*/}
                {/*        alt={"Scientists waiting to enter a room"}*/}
                {/*        width={"100%"}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className={"default-max-width"}>
                    <div
                        style={{
                            margin: "20px 20px 20px 20px"
                        }}
                    >
                        <Card>
                            <RegistrationForm onValidate={handleValidate} validateErrors={validate} watch={{name: "attendee", watch: onWatch}}/>
                            <ConsentForm watch={{name: "consent", watch: onWatch}}/>

                            {
                                consentValuesMissing || hasErrors() ? <div style={{
                                    color: "red",
                                    marginBottom: "10px",
                                    fontWeight: "bold"
                                }}>
                                    {consentValuesMissing ? "All checkboxes must be checked to register" :
                                        "All fields are required."}
                                </div> : ""
                            }


                            <div style={{
                                marginBottom: "20px"
                            }}>
                                <ThemeProvider theme={THEME}>
                                    <Button
                                        variant={"contained"}
                                        color={"primary"}
                                        style={{
                                            width: "180px"
                                        }}
                                        disabled={submitting}
                                        onClick={handleSubmit}
                                    >
                                        <span>SUBMIT</span>
                                        <span
                                            style={{
                                                    paddingLeft: "30px",
                                                    display: submitting ? "block" : "none"
                                                }}
                                        >
                                            <CircularProgress
                                                color={"white"}
                                                style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    marginTop: "5px"
                                                }}
                                            />
                                        </span>
                                    </Button>
                                </ThemeProvider>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>

            <FormModal
                title={"Invalid Registration"}
                open={modalOpen}
                width={400}
                height={525}
                content={
                    <div
                        style={{
                            marginTop: "30px",
                            marginLeft: "30px",
                            marginRight: "30px",
                            textAlign: "center"
                        }}
                    >
                        <div className={"default-font-color-dark"}>
                            Thank you for your interest in registering for the PACT Summit. We appreciate you
                            taking the time to complete the registration process.
                        </div>
                        <br/>
                        <div className={"default-font-color-dark"}>
                            Unfortunately, due to venue limitations, we are unable to accommodate Healthcare
                            Professionals (HCPs) and government officials for this event. We apologize
                            for any inconvenience this may cause.
                        </div>
                        <br/>
                        <div className={"default-font-color-dark"}>
                            We value your interest in the PACT Summit and encourage you to stay connected
                            with us for future events that may be more suitable for your participation.

                        <br/>
                            <br/>
                            Please contact contact@pactsummit.com if you have any questions.
                        </div>
                        <br/>
                        <div>
                            <ThemeProvider theme={THEME}>
                            <Button
                                variant={"contained"}
                                onClick={handleCloseModal}
                            >
                                CLOSE DIALOG
                            </Button>
                            </ThemeProvider>
                        </div>

                    </div>
                }
            />

        </React.Fragment>
    )
}